import React from 'react'

export interface ITableHead {
  label: string | null
  key: string
  col: number
  leftAlign?: boolean
  type?: HeadType
  unit?: string
}

export enum HeadType {
  Blank,
  Highlight,
}

export interface ITableHeadProps {
  head: ITableHead[]
}

export class Head extends React.Component<ITableHeadProps, {}> {
  public isHighlight(item: ITableHead) {
    return item.type === HeadType.Highlight
  }

  public render() {
    const { head } = this.props

    return (
      <div className="w-full flex pb-20 mb-10 border-b-1 border-black whitespace-pre-wrap items-end leading-14">
        {head.map(item => {
          return (
            <span
              key={item.key}
              className={`w-${
                item.col
              }/12 uppercase tracking-1.5 font-500 text-black text-10 text-right first-child:text-left`}
            >
              {item.label}
            </span>
          )
        })}
      </div>
    )
  }
}
